import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { useSnackbar } from '../context/SnackbarContext';
import {
    Box,
    Button,
    TextField,
    Typography,
    CircularProgress,
    Container,
} from '@mui/material';
import ForgotPassword from './ForgotPassword';

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [forgotOpen, setForgotOpen] = useState(false);
    const { exibirMensagem } = useSnackbar();
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email || !password) {
            exibirMensagem('Por favor, preencha todos os campos.', 'info');
            return;
        }

        setLoading(true);

        try {
            const response = await api.post('/api/auth/login', { email, senha: password });
            const { token } = response.data;
            console.log('Token recebido:', token);
            if (token) {
                localStorage.setItem('token', token);
                exibirMensagem('Login realizado com sucesso!', 'success');
                navigate('/clients');
            } else {
                exibirMensagem('Token não recebido do servidor.', 'error');
            }
        } catch (error: any) {
            const mensagemErro =
                error.response?.data?.error ||
                error.response?.data?.mensagem ||
                'Erro ao realizar login.';
            exibirMensagem(mensagemErro, 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Typography component="h1" variant="h5">
                    Login
                </Typography>
                <Box component="form" onSubmit={handleLogin} sx={{ mt: 3 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="E-mail"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Senha"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2, mb: 2 }}
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Entrar'}
                    </Button>
                    <Button
                        fullWidth
                        variant='outlined'
                        color='primary'
                        sx={{ mt: 2, mb: 2 }}
                        onClick={() => setForgotOpen(true)}
                    >
                        Esqueci minha senha
                    </Button>
                </Box>
            </Box>
            <ForgotPassword open={forgotOpen} onClose={() => setForgotOpen(false)} />
        </Container>
    );
};

export default Login;